import React from 'react'
import scroll from '../../assets/images/scroll.svg'
import { useTranslation } from 'react-i18next'
import bg1 from '../../assets/images/bg1.svg'

const HomeBanner = () => {
    const { t } = useTranslation()

    return (
        <div className='home-banner'>
            {/* <img src={bg1} alt='' /> */}
            <div className='content'>
                <div><h1>{t("home_banner")}</h1></div>
                <div className='mt-3 sub-text'><span className='f20 fw400 color2'>{t("home_banner_text")}</span></div>
                <div className='scroll'>
                    <div className='text-center'><img src={scroll} alt='' /></div>
                    <div className='text-center'><span className='f14 fw400 color2'>{t("scroll_discover")}</span></div>
                </div>
            </div>
        </div>
    )
}

export default HomeBanner
